export const environment = {
    production: false,
    ambiente : "Staging",
    apiUrl: 'https://demobpnd.italset.it/api',
    version: "2.4",
    versionDate: "16/07/2024",
  
    recaptcha: {
      siteKey: '6LfFr5InAAAAAFUvrcqXO4m4A3p7r-nE3VHA9Baz',
    },
  };